module.exports = __webpack_public_path__ + "img/bg.d0206afc.jpeg";